// extracted by mini-css-extract-plugin
export default {"podRow":"layout-podRow","podCol":"layout-podCol"};